import { render, staticRenderFns } from "./HuaxianPublicity.vue?vue&type=template&id=b7c1cd1a&scoped=true&"
import script from "./HuaxianPublicity.vue?vue&type=script&lang=js&"
export * from "./HuaxianPublicity.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianPublicity.vue?vue&type=style&index=0&id=b7c1cd1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c1cd1a",
  null
  
)

export default component.exports